import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { WS_EVENTS } from '../../../lib/websocket/events';
import { useWebSocket } from '../../../lib/websocket/WebSocketProvider';

import { SUPERVISOR_DASHBOARD_QUERY_KEY } from './use-supervisor-dashboard';
import { SUPERVISOR_WIDGETS_QUERY_KEY } from './use-supervisor-widgets';

/**
 * Liga os 3 WS events do Supervisor Dashboard (S10) à invalidação React Query.
 * R15 (Item 316): priority-queue-changed declarado mas ainda não emitido —
 * subscrever é inócuo; columnB real-time vem via snapshot-updated por ora.
 */
export function useSupervisorDashboardWsSync(): void {
  const qc = useQueryClient();
  const { subscribe } = useWebSocket();
  useEffect(() => {
    const offSnapshot = subscribe(WS_EVENTS.SUPERVISOR_DASHBOARD_SNAPSHOT_UPDATED, () => {
      void qc.invalidateQueries({ queryKey: [...SUPERVISOR_DASHBOARD_QUERY_KEY] });
    });
    const offQueue = subscribe(WS_EVENTS.SUPERVISOR_DASHBOARD_PRIORITY_QUEUE_CHANGED, () => {
      void qc.invalidateQueries({ queryKey: [...SUPERVISOR_DASHBOARD_QUERY_KEY] });
    });
    const offWidget = subscribe(WS_EVENTS.SUPERVISOR_DASHBOARD_WIDGET_PREFERENCE_CHANGED, () => {
      void qc.invalidateQueries({ queryKey: [...SUPERVISOR_WIDGETS_QUERY_KEY] });
    });
    return () => {
      offSnapshot();
      offQueue();
      offWidget();
    };
  }, [qc, subscribe]);
}
